import * as Hogan from 'hogan.js';
import { defaultTemplates } from './diff2html-templates';
export default class HoganJsUtils {
  constructor(_ref) {
    let {
      compiledTemplates = {},
      rawTemplates = {}
    } = _ref;
    const compiledRawTemplates = Object.entries(rawTemplates).reduce((previousTemplates, _ref2) => {
      let [name, templateString] = _ref2;
      const compiledTemplate = Hogan.compile(templateString, {
        asString: false
      });
      return Object.assign(Object.assign({}, previousTemplates), {
        [name]: compiledTemplate
      });
    }, {});
    this.preCompiledTemplates = Object.assign(Object.assign(Object.assign({}, defaultTemplates), compiledTemplates), compiledRawTemplates);
  }
  static compile(templateString) {
    return Hogan.compile(templateString, {
      asString: false
    });
  }
  render(namespace, view, params, partials, indent) {
    const templateKey = this.templateKey(namespace, view);
    try {
      const template = this.preCompiledTemplates[templateKey];
      return template.render(params, partials, indent);
    } catch (e) {
      throw new Error("Could not find template to render '".concat(templateKey, "'"));
    }
  }
  template(namespace, view) {
    return this.preCompiledTemplates[this.templateKey(namespace, view)];
  }
  templateKey(namespace, view) {
    return "".concat(namespace, "-").concat(view);
  }
}